import { ActionsUnion, createAction } from "store/helper";

import {
  IEntityCreate,
  IEntityCreateFailure,
  IEntityCreateSuccess,
  IEntityDelete,
  IEntityDeleteFailure,
  IEntityDeleteSuccess,
  IEntityFetchCollectionFailure,
  IEntityFetchCollectionSuccess,
  IEntityFetchFailure,
  IEntityUpdate,
  IEntityUpdateFailure,
  IEntityUpdateSuccess,
} from "../actions";

import { IEmailTemplate, IPreviewEmailTemplatePayload } from "./interfaces";

export enum EmailTemplateActionNames {
  FETCH_EMAIL_TEMPLATE_REQUEST = "ENTITIES/EMAIL_TEMPLATE/FETCH_REQUEST",
  FETCH_EMAIL_TEMPLATE_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/FETCH_SUCCESS",
  FETCH_EMAIL_TEMPLATE_FAILURE = "ENTITIES/EMAIL_TEMPLATE/FETCH_FAILURE",
  FETCH_EMAIL_TEMPLATE_BY_ID_REQUEST = "ENTITIES/EMAIL_TEMPLATE/FETCH_BY_ID_REQUEST",
  FETCH_EMAIL_TEMPLATE_BY_ID_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/FETCH_BY_ID_SUCCESS",
  FETCH_EMAIL_TEMPLATE_BY_ID_FAILURE = "ENTITIES/EMAIL_TEMPLATE/FETCH_BY_ID_FAILURE",
  UPDATE_EMAIL_TEMPLATE_REQUEST = "ENTITIES/EMAIL_TEMPLATE/UPDATE_REQUEST",
  UPDATE_EMAIL_TEMPLATE_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/UPDATE_SUCCESS",
  UPDATE_EMAIL_TEMPLATE_FAILURE = "ENTITIES/EMAIL_TEMPLATE/UPDATE_FAILURE",
  CREATE_EMAIL_TEMPLATE_REQUEST = "ENTITIES/EMAIL_TEMPLATE/CREATE_REQUEST",
  CREATE_EMAIL_TEMPLATE_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/CREATE_SUCCESS",
  CREATE_EMAIL_TEMPLATE_FAILURE = "ENTITIES/EMAIL_TEMPLATE/CREATE_FAILURE",
  TEST_EMAIL_TEMPLATE_REQUEST = "ENTITIES/EMAIL_TEMPLATE/TEST_REQUEST",
  TEST_EMAIL_TEMPLATE_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/TEST_SUCCESS",
  TEST_EMAIL_TEMPLATE_FAILURE = "ENTITIES/EMAIL_TEMPLATE/TEST_FAILURE",
  FETCH_PREVIEW_REQUEST = "ENTITIES/EMAIL_TEMPLATE/PREVIEW_REQUEST",
  FETCH_PREVIEW_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/PREVIEW_SUCCESS",
  FETCH_PREVIEW_FAILURE = "ENTITIES/EMAIL_TEMPLATE/PREVIEW_FAILURE",
  DELETE_EMAIL_TEMPLATE_REQUEST = "ENTITIES/EMAIL_TEMPLATE/DELETE_REQUEST",
  DELETE_EMAIL_TEMPLATE_SUCCESS = "ENTITIES/EMAIL_TEMPLATE/DELETE_SUCCESS",
  DELETE_EMAIL_TEMPLATE_FAILURE = "ENTITIES/EMAIL_TEMPLATE/DELETE_FAILURE",
}

export const EmailTemplateActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: () => createAction(EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_REQUEST),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSuccess: (payload: IEntityFetchCollectionSuccess<IEmailTemplate> & { defaultHtmlTemplate: string }) =>
    createAction(EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchById: (id: string) => createAction(EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_BY_ID_REQUEST, id),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchByIdSuccess: (payload: IEntityFetchCollectionSuccess<IEmailTemplate> & { defaultHtmlTemplate: string }) =>
    createAction(EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_BY_ID_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchByIdFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(EmailTemplateActionNames.FETCH_EMAIL_TEMPLATE_BY_ID_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update: (payload: IEntityUpdate<IEmailTemplate & { teamIDs: string[]; type?: string; transactionID?: string }>) =>
    createAction(EmailTemplateActionNames.UPDATE_EMAIL_TEMPLATE_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateSuccess: (payload: IEntityUpdateSuccess<IEmailTemplate>) =>
    createAction(EmailTemplateActionNames.UPDATE_EMAIL_TEMPLATE_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateFailure: (payload: IEntityUpdateFailure) =>
    createAction(EmailTemplateActionNames.UPDATE_EMAIL_TEMPLATE_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create: (payload: IEntityCreate<IEmailTemplate & { teamIDs: string[]; type?: string; transactionID?: string }>) =>
    createAction(EmailTemplateActionNames.CREATE_EMAIL_TEMPLATE_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createSuccess: (payload: IEntityCreateSuccess<IEmailTemplate>) =>
    createAction(EmailTemplateActionNames.CREATE_EMAIL_TEMPLATE_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createFailure: (payload: IEntityCreateFailure) =>
    createAction(EmailTemplateActionNames.CREATE_EMAIL_TEMPLATE_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  test: (emails: string[], content: IEmailTemplate["content"], type: string) =>
    createAction(EmailTemplateActionNames.TEST_EMAIL_TEMPLATE_REQUEST, { emails, content, type }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  testSuccess: () => createAction(EmailTemplateActionNames.TEST_EMAIL_TEMPLATE_SUCCESS, {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  testFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(EmailTemplateActionNames.TEST_EMAIL_TEMPLATE_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPreview: (payload: IPreviewEmailTemplatePayload) =>
    createAction(EmailTemplateActionNames.FETCH_PREVIEW_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPreviewSuccess: (payload: { text: string; html: string }) =>
    createAction(EmailTemplateActionNames.FETCH_PREVIEW_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchPreviewFailure: (payload: IEntityFetchFailure) =>
    createAction(EmailTemplateActionNames.FETCH_PREVIEW_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  delete: (payload: IEntityDelete) => createAction(EmailTemplateActionNames.DELETE_EMAIL_TEMPLATE_REQUEST, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSuccess: (payload: IEntityDeleteSuccess) =>
    createAction(EmailTemplateActionNames.DELETE_EMAIL_TEMPLATE_SUCCESS, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteFailure: (payload: IEntityDeleteFailure) =>
    createAction(EmailTemplateActionNames.DELETE_EMAIL_TEMPLATE_FAILURE, payload),
};

export type EmailTemplateAction = ActionsUnion<typeof EmailTemplateActions>;
